import styled from 'styled-components'
import ContainerContent from './../ContainerContent';
import { BigSIcon } from '../../assets/icons/bigSIcon'
import { Link } from 'react-router-dom'
import { createContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {getUrl} from "../../components/getSubjectId";
import { ConfigText } from '../healthStatus/HealthStatus'

const Background = styled.div<{ theme: string }>`
  position: relative;
  @media print {
    display: none;
  }
`

const Disclaimer = styled.div`
  margin-top: 60px;
  padding-bottom: 25px;
  margin-bottom: 25px;
  border-bottom: 1px solid #ededed;
  span {
    color: var(--text-secondary, #808080);
    /* Header/M Semibold */
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px; /* 177.778% */
    letter-spacing: 0.36px;
  }
  p {
    color: var(--text-secondary, #808080);
    /* Paragraph/S */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 166.667% */
    letter-spacing: 0.24px;
  }
`

const About = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 3;
`
const AboutText = styled.p`
  color: var(--text-secondary, #808080);
  /* Text/S Semibold */
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
  margin-right: 20px;
`
const LeftSide = styled.div``
const RightSide = styled.div`
  display: flex;
  align-items: center;
  a {
    color: #808080;
    cursor: pointer;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    margin-right: 24px;
    text-decoration: none;
    letter-spacing: 0.24px;
  }
`

const Logo = styled.div`
  position: absolute;
  z-index: 0!important;
  bottom: 0px;
  right: 0px;
  z-index: 1;
  height: fit-content;
  overflow: hidden;
  svg {
    transform: translateY(5px);
    opacity: 0.5;
  }
`
const Footer = () => {
  const { t } = useTranslation()
  const [theme, setTheme] = useState('dark');
  const location = useLocation();

  console.log('*........ ## RENDER 1', theme, location);

  const obj = /\/biomarkers|\/home|\/form/gi.test(location.pathname) ? {} : {'data-grey': true}

  return (
    <Background {...obj} data-footer>
      <Logo>
        <BigSIcon />
      </Logo>
      <ContainerContent background='transparent'>
        <div data-animch={0} >
          <div>
            <span className={'descTitle'}>
              <ConfigText field={'footer_name'}>{t('disclaimer')}</ConfigText>
            </span>
          <p className={'descFooter'}>
            <ConfigText field={'footer'}>
            {t('disclaimerText')}
            </ConfigText>
          </p>
          </div>
          <div>
            <div className={'footerHr'}></div>
          </div>
            {/* </Disclaimer> */}
          <About className={'footerLink'}>
            <LeftSide>
              <AboutText>
                <ConfigText field={'copyright'}>
                  {t('copyright')}
                </ConfigText>
                </AboutText>
            </LeftSide>
            <RightSide className={'z1'}>
            <Link to="https://editor.wix.com/html/editor/web/renderer/external_preview/document/457ab3bf-42f8-4efd-8b8c-1460405ee537/privacy-policy?metaSiteId=c32aa9d1-23d1-4474-9238-c37a570fd586&dsOrigin=externalPreview&configName=externalPreview">{t('imprint')}</Link>
              <Link to="https://editor.wix.com/html/editor/web/renderer/external_preview/document/457ab3bf-42f8-4efd-8b8c-1460405ee537/privacy-policy?metaSiteId=c32aa9d1-23d1-4474-9238-c37a570fd586&dsOrigin=externalPreview&configName=externalPreview">{t('privacyPolicy')}</Link>
              <Link to="https://editor.wix.com/html/editor/web/renderer/external_preview/document/457ab3bf-42f8-4efd-8b8c-1460405ee537/privacy-policy?metaSiteId=c32aa9d1-23d1-4474-9238-c37a570fd586&dsOrigin=externalPreview&configName=externalPreview">{t('generalTermsandConditions')}</Link>
              <Link to="https://editor.wix.com/html/editor/web/renderer/external_preview/document/457ab3bf-42f8-4efd-8b8c-1460405ee537/privacy-policy?metaSiteId=c32aa9d1-23d1-4474-9238-c37a570fd586&dsOrigin=externalPreview&configName=externalPreview">{t('productDisclaimer')}</Link>
            </RightSide>
          </About>
        </div>
      </ContainerContent>

    </Background>
  )
}

export default Footer
